import { getBaseURLForLanguage } from "./getBaseURLForLanguage";
import type { Href } from "expo-router";

export function getLocaleURL(url: Href): Href {
  const basePath = getBaseURLForLanguage(true);
  const basePathWithoutTrailingSlash =
    basePath.at(-1) === "/" ? basePath.slice(0, -1) : basePath;

  return (basePathWithoutTrailingSlash + url) as Href;
}
